/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React,{useState,useEffect} from "react";
// reactstrap components
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import '../css/index.css'
import clientFirebase from '../config/firebase_client'
import {connect} from "react-redux";
import {get_data} from "../store/acion/index.js"






function Map(props) {

  useEffect(()=>{
    // console.log("dsa",props.hotel_data.);
  props.get_data()
  document.getElementById('loadingSHOW').style.display='block'

},[])
  return (
    <>
    <div id="loadingSHOW" style={{display:'none'}}>
<div class="loading"> Loading&#8230;</div>

</div>

<div className="content">






<div style={{display:'flex',flexDirection:'row',flexWrap:'wrap',width:'100%',justifyContent:'center',alignItems:'center'}}>









{props.hotel_data.map((v,i)=>{
  return(
    
    <div key={i}  onClick={()=>{ props.history.push('/admin/edit',{branch:v});
    
  }} id='main_edit_0' style={{display:'flex',width:'40%',flexDirection:'column',backgroundColor:'white',borderRadius:'12px',margin:'3%',padding:'2%',boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'}}>
  <img className="cardImage" src={v.Images[0].url}></img>
  

<div style={{display:'flex',flexDirection:'row',marginTop:'5%',marginLeft:'1%'}}>
<span style={{fontFamily:'revert',fontWeight:'bold',fontSize:'16px',color:'#73716E'}}>Branch Name: </span>
<span style={{fontFamily:'monospace',fontWeight:'bolder',fontSize:'18px',color:'#73716E',marginLeft:'3%'}}> {v.hotelName}  </span>
</div>

<div style={{display:'flex',flexDirection:'row',marginTop:'1%',marginBottom:'1%',marginLeft:'1%'}}>
<span style={{fontFamily:'revert',fontWeight:'bold',fontSize:'16px',color:'#73716E'}}>Branch Manager: </span>
<span style={{fontFamily:'monospace',fontWeight:'bolder',fontSize:'18px',color:'#73716E',marginLeft:'3%'}}> {v.name} </span>
</div>



<div style={{display:'flex',flexDirection:'row',marginTop:'0%',marginBottom:'1.3%'}}>


</div>


<div style={{display:'flex',flexDirection:'row',marginTop:'20%',marginBottom:'0.3%'}}>
<span style={{fontFamily:'monospace',fontWeight:'bolder',fontSize:'15px',color:'#96938E'}}>Note: </span>
<span style={{fontFamily:'monospace',fontWeight:'900',fontSize:'14px',color:'#96938E',marginLeft:'3%'}}>Click to  Edit or Add  room  in branch & Delete branch  </span>
</div>




  </div>
    )
  })}






{/* 
  <div  onClick={()=>{props.history.push('/admin/edit')}} id='main_edit_0' style={{display:'flex',width:'40%',flexDirection:'column',backgroundColor:'white',borderRadius:'12px',margin:'3%',padding:'2%',boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'}}>
  <img style={{width:'100%'}} src='https://images.unsplash.com/photo-1618773928121-c32242e63f39?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8aG90ZWx8ZW58MHx8MHx8&w=1000&q=80'></img>
  

<div style={{display:'flex',flexDirection:'row',marginTop:'5%',marginLeft:'1%'}}>
<span style={{fontFamily:'revert',fontWeight:'bold',fontSize:'16px',color:'#73716E'}}>Branch Name: </span>
<span style={{fontFamily:'monospace',fontWeight:'bolder',fontSize:'18px',color:'#73716E',marginLeft:'3%'}}> Main Branch  </span>
</div>

<div style={{display:'flex',flexDirection:'row',marginTop:'1%',marginBottom:'1%',marginLeft:'1%'}}>
<span style={{fontFamily:'revert',fontWeight:'bold',fontSize:'16px',color:'#73716E'}}>Branch Manager: </span>
<span style={{fontFamily:'monospace',fontWeight:'bolder',fontSize:'18px',color:'#73716E',marginLeft:'3%'}}> Hassan </span>
</div>



<div style={{display:'flex',flexDirection:'row',marginTop:'0%',marginBottom:'1.3%'}}>
<button type="button" style={{backgroundColor:'#326EC6'}} class="btn btn-primary">Delete</button>

</div>


<div style={{display:'flex',flexDirection:'row',marginTop:'1%',marginBottom:'0.3%'}}>
<span style={{fontFamily:'monospace',fontWeight:'bolder',fontSize:'15px',color:'#96938E'}}>Note: </span>
<span style={{fontFamily:'monospace',fontWeight:'900',fontSize:'14px',color:'#96938E',marginLeft:'3%'}}>Click to edit or add room in branch  </span>
</div>




  </div> */}













  


</div> 











      </div>


   
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    hotel_data:state.hotel_data,
  }
}


const mapDispatchToProps = dispatch => {
  return {
    // dispatching plain actions
    get_data: () => dispatch(get_data())  
  
  }}
  export default connect(mapStateToProps,mapDispatchToProps)(Map)